import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_CONTRATTO } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolContrattoState extends EntityState<IID_OL_CONTRATTO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_CONTRATTO })
@InterfaceDataStore(InterfaceName.CONTRATTO)
export class IIDolContrattoStore extends EntityStore<IIDolContrattoState> {
  constructor() {
    super([]);
  }
}
